import Modal from '../../../../components-manual/ui/modal.vue';
import { useModalStore } from '../../../../store/useModalStore';

export default {
  install(Vue) {
    const modalStore = useModalStore();

    const $modal = {
      show: (name) => {
        modalStore.openModal(name);
      },
      hide: (name) => {
        modalStore.closeModal(name);
      },
    };

    /** @deprecated */
    Vue.config.globalProperties.$modal = $modal;

    /** for vue 3 */
    Vue.provide('$modal', $modal);

    Vue.component('modal', Modal);
  }
};
